import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class QuestionsService {

  constructor(private readonly http: HttpClient) {

  }

  public getQuestionsByIds(post: any) {
    const questionsUrl = environment.INNOVATE_API_V2 + 'questions';
    const body = JSON.stringify(post);
    return this.http.post(questionsUrl, body);
  }

}